import React from 'react';

import aeroplaneImage from './img/flight.png';
import mapImage from './img/map.png';
import referImage from './img/wallet.png';

import HeadingH3 from '../../components/UI/Headings/HeadingH3/HeadingH3';
import HeadingH4 from '../../components/UI/Headings/HeadingH4/HeadingH4';

const quickServices = () => (
    <div className={`u-backgroundColorWhite u-transitionAll300Ease u-borderRadius4 u-boxShadowThin u-flex`}>
        <div className={`u-borderRightNormal pt-6 pb-6 u-flex justify-content-center align-items-center f-fill f-column`}>
            <div className={`mb-3`}>
                <img src={aeroplaneImage} alt='Quick Service Aeroplane' className={`u-size60x60`}/>
            </div>
            <div className={`mb-1`}>
                <HeadingH3 size={16} weight="Regular" color="Dark">Check Flight Status</HeadingH3>
            </div>
            <div>
                <HeadingH4 size={11} weight="Regular" color="Light">Get more personalized</HeadingH4>
            </div>
            <span></span>
        </div>
        <div style={{flex: '0 0 70%'}} className={`u-flex justify-content-center align-items-center f-column pl-7 pr-7 u-width100Percent`}>
            <div className={`u-borderBottomNormal pb-6 pt-6 u-flex justify-content-between align-items-center u-width100Percent`}>
                <div className={`u-flex`}>
                    <div className={`mr-4`}>
                        <img src={mapImage} alt='Quick Service Map' className={`u-size40x40`}/>
                    </div>
                    <div>
                        <HeadingH3 size={16} weight="Regular" color="Dark">Let's Explore</HeadingH3>
                        <HeadingH4 size={11} weight="Regular" color="Light">Get more personalized experience</HeadingH4>
                    </div>
                </div>
                <div></div>
            </div>
            <div className={`pt-6 pb-6 u-flex justify-content-between align-items-center u-width100Percent`}>
                <div className={`u-flex`}>
                    <div className={`mr-4`}>
                        <img src={referImage} alt='Quick Service Refer' className={`u-size40x40`}/>
                    </div>
                    <div>
                        <HeadingH3 size={16} weight="Regular" color="Dark">Refer &amp; Earn</HeadingH3>
                        <HeadingH4 size={11} weight="Regular" color="Light">Get more personalized experience.</HeadingH4>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
    </div>
);

export default quickServices;


// WEBPACK FOOTER //
// ./src/components/QuickServices/QuickServices.js